"use client";

import { formatPrice } from "@/lib/format";

type Props = {
  pricePerNight: number;
  currency: string;
  ratingAvg: number | null;
  reviewCount: number;
};

export default function MobileReserveBar({ pricePerNight, currency, ratingAvg, reviewCount }: Props) {
  function scrollToReserve() {
    document.getElementById("reserve")?.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  return (
    // Sits ABOVE the mobile bottom-nav (64-px tall, z-900) so the
    // Reserve button stays reachable. z-index 905 keeps it above the
    // nav itself; safe-area inset still applies inside the nav, not
    // here. Use bottom: 64px to clear the nav's height.
    <div
      className="md:hidden fixed left-0 right-0 bg-white border-t border-neutral-200 px-4 py-3 flex items-center justify-between gap-3 shadow-lg"
      style={{ bottom: "64px", zIndex: 905 }}
    >
      <div className="min-w-0">
        <div className="text-base font-semibold leading-tight">
          {formatPrice(pricePerNight, currency)}
          <span className="text-sm font-normal text-neutral-500"> / night</span>
        </div>
        {ratingAvg != null ? (
          <div className="text-xs text-amber-600 mt-0.5">★ {ratingAvg.toFixed(1)} <span className="text-neutral-500">({reviewCount})</span></div>
        ) : null}
      </div>
      <button
        onClick={scrollToReserve}
        // 44px min-height so iOS tap targets pass guidelines.
        className="bg-rose-600 hover:bg-rose-700 text-white rounded-lg px-5 py-3 min-h-[44px] text-sm font-semibold shrink-0"
      >
        Reserve
      </button>
    </div>
  );
}
